export const borders = {
  borderWidths: {
    md: '1px',
  },
}
